export default __webpack_public_path__ + "static/media/smallSignedCheck.cb5905bb.svg";